import { render, staticRenderFns } from "./conversationsDetail.vue?vue&type=template&id=16e65337&scoped=true&"
import script from "./conversationsDetail.vue?vue&type=script&lang=js&"
export * from "./conversationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./conversationsDetail.vue?vue&type=style&index=0&id=16e65337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e65337",
  null
  
)

export default component.exports